import React from "react";
import { Toaster } from "sonner";
import "sonner/dist/styles.css";

/**
 * Global premium toast host (Sonner) — top-right, used app-wide.
 * Page-level react-hot-toast <Toaster /> components are no-ops via the shim.
 */
export default function AppToaster() {
  return (
    <Toaster
      position="top-right"
      richColors
      closeButton={false}
      expand={false}
      visibleToasts={5}
      gap={10}
      offset={16}
      duration={1000}
      toastOptions={{
        classNames: {
          toast: "jg-toast",
          title: "jg-toast-title",
          description: "jg-toast-description",
          actionButton: "jg-toast-action",
          cancelButton: "jg-toast-cancel",
          closeButton: "jg-toast-close",
        },
      }}
    />
  );
}
